import api from '../utils/api';

export const getHomepageContent = async () => {
    try {        
        const res = await api.get(
            '/api/homepage-content' +
            '?populate[A_block_image]=true' +
            '&populate[C_block_image]=true' +
            '&populate[E_block_image]=true' +
            '&populate[D_block_cards][populate]=icon' +
            '&populate[E_block_cards][populate]=icon' +
            '&populate[F_block_cards][populate]=icon' +
            '&populate[G_block_cards][populate]=icon'
        );
        return res.data.data;
    } catch (e) {
        console.error(e);
        throw e;
    }
}

export const getOurStoryContent = async () => {
    try {        
        const res = await api.get(
            '/api/our-story-content' +
            '?populate[A_block_image]=true' +
            '&populate[C_block_image]=true'
        );
        return res.data.data;
    } catch (e) {
        console.error(e);
        throw e;
    }
}

export const getSolutionsContent = async () => {
    try {
        const res = await api.get(
            '/api/solution-content' +
            '?populate[A_block_image]=true' +
            '&populate[B_block_left_card][populate][image]=true' +
            '&populate[B_block_left_card][populate][icon]=true' +
            '&populate[B_block_cards][populate]=icon' +
            '&populate[B_block_left_card][populate]=icon' +
            '&populate[C_block_cards][populate][image]=true' +
            '&populate[C_block_cards][populate][subcard][populate][icon]=true' +
            '&populate[E_block_cards_sections][populate][cards][populate][icon]=true' +
            '&populate[F_block_image]=true' +
            '&populate[F_block_A_cards][populate]=icon' +
            '&populate[F_block_B_card][populate]=icon' +
            '&populate[G_block_cards][populate]=icon'
        );
        return res.data.data;
    } catch (e) {
        console.error(e);
        throw e;
    }
}

export const getForWhomContent = async () => {
    try {        
        const res = await api.get(
            '/api/for-whom-content' +
            '?populate[A_block_image]=true' +
            '&populate[sections][populate][image]=true' +
            '&populate[sections][populate][Block_cards][populate][icon]=true' +
            '&populate[sections][populate][Section_presentation_card][populate][icon]=true' +
            '&populate[sections][populate][Section_presentation_card][populate][image]=true'
        );
        return res.data.data;
    } catch (e) {
        console.error(e);
        throw e;
    }
}

export const getForWhomMenuContent = async () => {
    try {        
        const res = await api.get(
            '/api/for-whom-content' +
            '?populate[sections][populate][Section_presentation_card][populate][icon]=true'
        );
        return res.data.data;
    } catch (e) {
        console.error(e);
        throw e;
    }
}

export const getStoreContent = async () => {
    try {        
        const res = await api.get('/api/store-content');
        return res.data.data;
    } catch (e) {
        console.error(e);
        throw e;
    }
}

export const getTrainingContent = async () => {
    try {        
        const res = await api.get('/api/training-content');
        return res.data.data;
    } catch (e) {
        console.error(e);
        throw e;
    }
}